import {AddNotesModal} from "../../../../components/non-employee/contract-employee/add-notes-modal/AddNotesModal";
import {useState} from "react";

export const AddNotesModalContainer = ({show, onHide, onSubmitModal, employeeDetail, contractDetail}) => {
    const [notes, setNotes] = useState('')

    const onSubmitForm = () => {
        onSubmitModal(notes)
        onHide()
    }

    const props = {
        onSubmitForm,
        title: 'Notes',
        show,
        onHide,
        notes,
        setNotes,
        employeeDetail,
        contractDetail
    }

    return (
        <AddNotesModal {...props}/>
    )
}
